import { useForm } from 'react-hook-form';
import { FormInput } from '../../../wrappers/formInput';
import Button from '../../../components/button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export type ForgotFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  password: any;
  defaultValue:any;

};

interface Props {

  ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void,
   
  }

  const validationSchema = Yup.object({
    email: Yup.string()
      .required("Field is required")
      .email('Please provide a valid email address'),
  });

export const ForgotPasswordForm: React.FC <Props> = ({ClickHandler}) => {

  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotFormFields>(formOptions);
   
  const onSubmit = (data: any) => {
    ClickHandler(data)
  }

  return (
    <form >
      <div className="form-group">
      <FormInput<ForgotFormFields>
        id="email"
        type="email"
        name="email"
        size="medium"
        placeholder="Email Address"
        label=""
        register={register}
        errors={errors}
      />
      </div>
      <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="large">Send Reset Password Link</Button>
    </form>
  );
};

